import React, { Component } from 'react';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import moment from 'moment';

export default class Grid extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showContextRibbon: this.props.showContextRibbon,
            showMessageContextRibbon: this.props.showMessageContextRibbon,
            isSelectable: true,
            sortable: false,
            selected: [],
            selectAll: 0,
            data: this.props.DataSet,
            nestedData: this.props.NestedDataSet === undefined ? null : this.props.NestedDataSet,
            columns: this.props.ColumnData === undefined ? null : this.getColumns(this.props.ColumnData),
            subColumns: this.props.IsNested === true ? this.getColumns(this.props.NestedColumnData) : false,
            totalRecords: this.props.TotalRecords,
            startIndex: this.props.StartIndex,
            endIndex: this.props.EndIndex,
            disablePre: true,
            disableNext: this.checkifNeedtoDisable(),
            disableStart: true,
            disableLast: this.checkifNeedtoDisable(),
            dataLimit: this.props.DataLimit,
            Manual: this.props.Manual,
            showNavigation: this.props.showNavigation === undefined ? true : this.props.showNavigation,
            selectedRadio: '',
            singleSelected: null,
            noDataText: 'No results found!'
        }


        this.handlePagination = this.handlePagination.bind(this);

    };
    checkifNeedtoDisable() {

        if (this.props.TotalRecords == 0|| (this.props.TotalRecords <= (this.props.EndIndex + 1 - this.props.StartIndex))) {
            return true;
        }
        return false;
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            data: nextProps.DataSet,
            totalRecords: nextProps.TotalRecords,
            endIndex: nextProps.EndIndex,
            startIndex: nextProps.StartIndex,
            dataLimit: nextProps.DataLimit,
            disablePre: nextProps.DisablePre,
            disableNext: nextProps.DisableNext,
            disableStart: nextProps.DisableStart,
            disableLast: nextProps.DisableLast,
            noDataText: nextProps.noDataText,
            Manual: nextProps.Manual,
        });

        if (nextProps.TotalRecords === 0 || nextProps.TotalRecords <= (nextProps.EndIndex + 1 - nextProps.StartIndex)) {
            this.setState({
                disablePre: true, disableStart: true, disableNext: true, disableLast: true
            });
        }

        if (nextProps.EndIndex === this.state.totalRecords) {
            this.setState({
                disableNext: true, disableLast: true
            });
        }
        if (nextProps.StartIndex === 1) {
            this.setState({
                disablePre: true, disableStart: true
            });
        }



    }
    getColumns = (columnsDescription) => {
        const newColumnList = [];
        var column = {};

        columnsDescription.map((item) => {
            if (item.ColumnType === "expander") {
                column = {
                    expander: true,
                    Expander: ({ isExpanded, ...rest }) => {
                        return (<span className={"data-table-expander-alignment"}>
                            {isExpanded
                                ? <i className="fa fa-angle-up" />
                                : <i className="fa fa-angle-down" />}
                        </span>)
                    },
                    className: "data-table-expander"
                };
            };
            if (item.ColumnType === "checkbox") {
                column = {
                    id: item.Id,
                    accessor: item.Title,
                    className: item.ClassName,
                    Cell: ({ original }) => {
                        return (
                            <input
                                type="checkbox"
                                className="checkbox"
                                checked={this.state.selected.includes(original) === true}
                                onChange={(event) => this.toggleRow(event, original)}
                            />
                        );
                    },
                    Header: x => {
                        return (
                            <input
                                type="checkbox"
                                className="checkbox"
                                checked={this.state.selectAll === 1}
                                ref={input => {
                                    if (input) {
                                        input.indeterminate = this.state.selectAll === 2;
                                    }
                                }}
                                onChange={() => this.toggleSelectAll()}
                            />
                        );
                    },
                    sortable: item.Sortable,
                    width: 45
                };
            }
            if (item.ColumnType === 'radio') {
                column = {
                    id: item.Id,
                    accessor: item.Title,
                    className: "checkbox",
                    Cell: ({ original }) => {
                        return (
                            <input
                                type="radio"
                                name={"rowOption"}
                                checked={this.state.selectedRadio === "radio" + original.id}
                                value={"radio" + original.id}
                                onChange={(event) => this.addSingleSelect(event, original)}
                            />
                        );
                    },
                    sortable: false,
                    width: 45
                };
            }
            if (item.ColumnType === "boolean") {
                column = {
                    id: item.Id,
                    headerClassName: item.ClassName,
                    Header: item.Title,
                    accessor: item.Accessor,
                    Cell: e => <input
                        type="checkbox"
                        className="checkbox"
                        checked={e.value}
                    />
                }
            }
            if (item.ColumnType === "FileProcessStatus") {
                var cloumnValue = '';


                // alert(Item.value);

                column = {
                    id: item.Id,
                    headerClassName: item.ClassName,
                    Header: item.Title,
                    accessor: item.Accessor,
                    Cell: e => {
                        if (e.value === 'N' || e.value === 'H') {

                            cloumnValue = 'Hold';
                        }
                        else if (e.value === 'S') {
                            cloumnValue = 'Success';

                        }
                        else if (e.value === 'F') {

                            cloumnValue = "Failed";
                        }
                        else {
                            return (
                                <div>{e.value}</div>);
                        }
                        return (
                            <div>{cloumnValue}</div>);
                    }

                };


            }
            if (item.ColumnType === "CartonRejectionStatus") {
                var cloumnvalue = '';


                // alert(Item.value);

                column = {
                    id: item.Id,
                    headerClassName: item.ClassName,
                    Header: item.Title,
                    accessor: item.Accessor,
                    Cell: e => {
                        if (e.value === 'P') {

                            cloumnvalue = 'Pass';
                        }
                        else if (e.value === 'R') {
                            cloumnvalue = 'Rejected';

                        }
                        else {
                            return (
                                <div>{e.value}</div>);
                        }
                        return (
                            <div>{cloumnvalue}</div>);
                    }

                };


            }
            if (item.ColumnType === "Text") {

                column = {
                    id: item.Id,
                    headerClassName: item.ClassName,
                    Header: item.Title,
                    accessor: item.Accessor,
                    Cell: item.Editable === true ? this.renderEditable : undefined
                };
            }


            if (item.ColumnType === "MergedColumn") {
                column = {
                    id: item.Id,
                    headerClassName: item.ClassName,
                    Header: item.Title,
                    accessor: d => {
                        return d.mode + " | " + d.inco;
                    },
                    sortable: item.Sortable,
                    Cell: item.Editable === true ? this.renderEditable : undefined
                };
            }
            if (item.ColumnType === "HyperLink") {
                if (item.Accessor === "truckingNumber") {
                    column = {
                        id: item.Id,
                        headerClassName: item.ClassName,
                        Header: item.Title,
                        accessor: item.Accessor,
                        sortable: item.Sortable,
                        Cell: e => <a href={item.Url + e.original.id}> {e.value} </a>
                    }
                }
                else if (item.Accessor === "bookingNumber") {
                    column = {
                        id: item.Id,
                        headerClassName: item.ClassName,
                        Header: item.Title,
                        accessor: item.Accessor,
                        sortable: item.Sortable,
                        Cell: e => <a href={item.Url + e.original.bookingId}> {e.value} </a>
                    }
                }
            }
            if (item.ColumnType === "ClickableText") {
                column = {
                    headerClassName: item.ClassName,
                    Header: item.Title,
                    accessor: item.Accessor,
                    sortable: item.Sortable,
                    Cell: e => <a href="javascript:void(0);" onClick={() => this.props.showModal('single', e.index)}> {e.value} </a>
                }
            }
            if (item.ColumnType === "DownloadableText") {
                column = {
                    headerClassName: item.ClassName,
                    Header: item.Title,
                    accessor: item.Accessor,
                    sortable: item.Sortable,
                    Cell: e => <a href="javascript:void(0);" onClick={() => this.props.download(e.value)}> Download </a>
                }
            }
            if (item.ColumnType === "Delete") {
                column = {
                    headerClassName: item.ClassName,
                    Header: item.Title,
                    accessor: item.Accessor,
                    sortable: item.Sortable,
                    Cell: e => <a href="javascript:void(0);" onClick={() => this.props.delete(e)}> Delete </a>
                }
            }
            if (item.ColumnType === "Edit") {
                column = {
                    headerClassName: item.ClassName,
                    Header: item.Title,
                    accessor: item.Accessor,
                    sortable: item.Sortable,
                    Cell: e => <a href="javascript:void(0);" onClick={() => this.props.edit(e)}> Edit </a>
                }
            }
            if (item.ColumnType !== undefined && item.ColumnType === "DateTime") {
                column = {
                    id: item.Id,
                    headerClassName: item.ClassName,
                    Header: item.Title,
                    accessor: d => {
                        return this.splitDateTime(d.receivingDate, item.dataFormat, item.timeFormat);
                    },
                    sortable: item.Sortable,
                    Cell: item.Editable === true ? this.renderEditable : undefined
                }
            }
            if (item.ColumnType === "Submit") {
                column = {
                    headerClassName: item.ClassName,
                    Header: item.Title,
                    accessor: item.Accessor,
                    sortable: item.Sortable,
                    Cell: e => {
                        if (e.value === 'Fail') {
                            return < a href="javascript:void(0);" onClick={() => this.props.onSubmit(e)}> Retry </a >
                        }
                        else {
                            return <div> Retry </div>
                        }
                    }
                }
            }
            if (item.ColumnType !== undefined && item.ColumnType === "Multiple") {
                column = {
                    id: item.Id,
                    headerClassName: item.ClassName,
                    Header: item.Title,
                    accessor: d => {
                        return this.manageMultipleException(d.exceptions);
                    },
                    sortable: item.Sortable,
                    Cell: item.Editable === true ? this.renderEditable : undefined
                };
            }
            newColumnList.push(column);
        });
        return newColumnList;
    };

    splitDateTime = (date, dataFormat, timeFormat) => {
        // Date format can be directly changed by localization. Stored with "Key = dataFormat"
        return moment(new Date(date)).format(dataFormat) + " | " + moment(new Date(date)).format(timeFormat);
    };

    addSingleSelect = (event, original) => {
        this.setState({
            singleSelected: original,
            selected: [original],
            selectedRadio: 'radio' + original.id,
        });

        let table = document.getElementsByClassName('data-table');
        let checkboxRows = table.length > 0 ? table[0].getElementsByClassName('rt-tr-group') : document.getElementsByClassName('rt-tr-group');

        for (let i = 0; i < checkboxRows.length; i++) {
            checkboxRows[i].classList.remove('-selected');
        }
        let parent = event.target.parentNode.parentNode.parentNode;
        if (event.target.checked) {
            parent.classList.add("-selected");
        }

        this.props.handleSelection(original);

    };

    manageMultipleException = (exceptions) => {
        if (exceptions.length > 1) {
            return "Multiple";
        }
        else if (exceptions.length === 0) {
            return "NA";
        }
        else {
            return exceptions[0];
        }
    };

    getColumnHeader = (rowInfo, headerTxt) => {
        return (
            <div className="data-table-inline">
                <span>{headerTxt}</span>
                <i className="fa fa-sort" aria-hidden="true" />
            </div>
        );
    };

    renderEditable = (cellInfo) => {
        return (
            <div
                className={"data-table-pointer"}
                contentEditable
                suppressContentEditableWarning
                onFocus={e => {
                    e.target.classList.add("text-box");
                }}
                onBlur={e => {
                    const data = [...this.state.data];
                    data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
                    e.target.classList.remove("text-box");
                    this.setState({ data });
                }}
                //dangerouslySetInnerHTML={{
                //    __html: DOMPurify.sanitize(this.state.data[cellInfo.index][cellInfo.column.id])
                //}}
            />
        );
    };

    focusTableSelect = (event) => {
        event.target.classList.remove("select-box");
    };

    blurTableSelect = (event) => {
        event.target.classList.add("select-box");
    };

    renderSelectEditable = (cellInfo) => {
        return (
            <select name={"name-" + cellInfo.index + "-" + cellInfo.column.id} className="select-box"
                value={this.state.data[cellInfo.index][cellInfo.column.id]}
                onChange={(event) => this.handleDataTableSelect(cellInfo.index, cellInfo.column.id, event)}
                onFocus={this.focusTableSelect} onBlur={this.blurTableSelect}>
                <option />
                <option key={cellInfo.index}
                    value={this.state.data[cellInfo.index][cellInfo.column.id]}>
                    {this.state.data[cellInfo.index][cellInfo.column.id]}
                </option>
                <option key={"key-1"} value={"Data 1"}>Data 1</option>
                <option key={"key-2"} value={"Data 2"}>Data 2</option>
            </select>
        );
    };

    handleDataTableSelect = (index, columnId, event) => {
        let dataObj = this.state.data;
        dataObj[index][columnId] = event.target.value;
        this.setState({
            data: dataObj
        });
    };

    logSelection = () => {
    };

    updateSelectAll = () => {
        if (this.state.selected.length === 0) {
            this.setState({
                selectAll: 0
            }, () => {
                let table = document.getElementsByClassName('data-table');
                let checkboxRows = table.length > 0 ? table[0].getElementsByClassName('rt-tr-group') : document.getElementsByClassName('rt-tr-group');
                for (let i = 0; i < checkboxRows.length; i++) {
                    if (checkboxRows[i].classList.contains('-selected')) checkboxRows[i].classList.remove('-selected');
                }
            });

        } else {
            if (this.state.data !== null) {
                if (this.state.selected.length === this.state.data.length) {
                    this.setState({
                        selectAll: 1
                    });
                } else {
                    this.setState({
                        selectAll: 2
                    });
                }
                this.showContextRibbon();
            }
        }

    };

    toggleRow = (event, original) => {
        if (event.target.checked) {
            this.setState({
                selected: [...this.state.selected, original]
            }, () => {
                this.updateSelectAll();
            });
        }
        else {
            const toDelete = new Set([original]);
            let newArr = this.state.selected.filter(obj => !toDelete.has(obj));
            this.setState({
                selected: newArr
            }, () => {
                this.updateSelectAll();
            });

            this.props.handleSelection(newArr);
        }

        let parent = event.target.parentNode.parentNode.parentNode;
        if (event.target.checked) {
            parent.classList.add("-selected");
        }
        else {
            parent.classList.remove("-selected");
        }
    };

    toggleSelectAll = () => {
        let table = document.getElementsByClassName('data-table');
        let checkboxRows = table.length > 0 ? table[0].getElementsByClassName('rt-tr-group') : document.getElementsByClassName('rt-tr-group');

        if (this.state.selectAll !== 1) {
            for (let i = 0; i < checkboxRows.length; i++) {
                if (!checkboxRows[i].classList.contains('-selected')) checkboxRows[i].classList.add('-selected');
            }
            this.setState({
                selected: this.state.data
            }, () => {
                this.showContextRibbon();
            });

        }
        else {
            for (let i = 0; i < checkboxRows.length; i++) {
                if (checkboxRows[i].classList.contains('-selected')) checkboxRows[i].classList.remove('-selected');
            }
            this.setState({
                selected: []
            }, () => {
                this.hideContextRibbon();
            });
        }

        this.setState({
            selectAll: this.state.selectAll === 1 ? 0 : 1
        });
    };

    hideContextRibbon = () => {
        let table = document.getElementsByClassName('data-table');
        let checkboxRows = table.length > 0 ? table[0].getElementsByClassName('rt-tr-group') : document.getElementsByClassName('rt-tr-group');
        for (let i = 0; i < checkboxRows.length; i++) {
            if (checkboxRows[i].classList.contains('-selected')) checkboxRows[i].classList.remove('-selected');
        }
        this.setState({
            selected: [],
            selectedRadio: ''
        }, () => {
            this.props.handleSelection(this.state.selected);
            this.updateSelectAll();
        });

    };

    showContextRibbon = () => {
        this.props.handleSelection(this.state.selected);
    };

    handlePagination = (direction) => {
        this.props.onClick(direction);
    };

    render() {
        const { data } = this.state;
        const { columns } = this.state;
        const { subColumns } = this.state;
        const { sortable } = this.state.sortable;
        const { IsNested } = this.props.IsNested;
        return (
            <div className="data-table-container">
                <div className="grid-toolbar">
                    {
                        (this.state.showNavigation) ?
                            <div className="pagination-wrapper">
                                <ul className="pagination">
                                    <li>
                                        <button id="local_pagination_first" type="button" className="first-page button button-transparent" disabled={this.state.disableStart} onClick={() => this.handlePagination("first")}>First</button>
                                    </li>
                                    <li>
                                        <button id="local_pagination_prev" type="button" className="pre-page button button-secondary button-transparent" disabled={this.state.disablePre} onClick={() => this.handlePagination("previous")}><i className="fa fa-angle-left" aria-hidden="true" /></button>
                                    </li>
                                    <li><span className="page-results"> {this.state.startIndex} to {this.state.endIndex} out of {this.state.totalRecords} rows </span></li>
                                    <li>
                                        <button id="local_pagination_next" type="button" className="next-page button button-secondary button-transparent" disabled={this.state.disableNext} onClick={() => this.handlePagination("next")}><i className="fa fa-angle-right" aria-hidden="true" /></button>
                                    </li>
                                    <li>
                                        <button id="local_pagination_last" type="button" className="last-page button button-transparent" disabled={this.state.disableLast} onClick={() => this.handlePagination("last")} >Last</button>
                                    </li>
                                </ul>
                            </div>
                            : ""
                    }
                </div>
                {
                    (this.props.showContextRibbon) ?
                        <div className={"grid-toolbar context-ribbon"}>
                            <div className="button-group context-left" role="group" aria-label="Action buttons">{this.props.children}
                            </div>
                            <div className={"context-right"}>
                                <span className={"selected-count"}>{this.state.selected.length} selected</span>
                                <button type="button" className="button button-context" onClick={this.hideContextRibbon}>Cancel</button>
                            </div>
                        </div>
                        : ""
                }
                {
                    (this.props.showMessageContextRibbon) ?
                        <div className={"grid-toolbar context-ribbon"}>
                            <div className="button-group context-left" role="group" aria-label="Action buttons">
                                <label>{this.props.warning}</label>
                            </div>
                            <div className={"context-right"}>
                                <span className={"selected-count"}>{this.state.selected.length} selected</span>
                                <button type="button" className="button button-context" onClick={this.hideContextRibbon}>Cancel</button>
                            </div>
                        </div> : ""
                }


                <ReactTable
                    key={this.state.dataLimit}
                    data={data}
                    columns={columns}
                    defaultPageSize={this.state.dataLimit}
                    showPageSizeOptions={true}
                    showPagination={false}
                    sortable={sortable}
                    className={"data-table dam-no-results--msg"}
                    noDataText={this.state.noDataText}
                    manual={this.state.Manual}
                    onSortedChange={(state) => { this.props.handleSorting(state[0].id) }}
                    SubComponent={(this.props.IsNested) ? ((row) => {
                        return (
                            <div className="subComponent data-table-padding">
                                <ReactTable
                                    data={row.original.orders}
                                    columns={this.state.subColumns}
                                    defaultPageSize={row.original.orders.length <= 10 ? row.original.orders.length : 10}
                                    showPagination={false}

                                />
                            </div>
                        );
                    })
                        :
                        null}
                    onExpandedChange={(newExpanded, index, event, expanded) => {
                    }}
                />

            </div>

        );
    };
};